/*
Copyright 2017 - 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with the License. A copy of the License is located at
    http://aws.amazon.com/apache2.0/
or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and limitations under the License.
*/

import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
//import Table, { TableBody, TableCell, TableHead, TableRow } from '@material-ui/Table';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { Link } from 'react-router-dom';

import CarLogo from '../CarLogo';

import CircularProgress from '@material-ui/core/CircularProgress';
import { removeDollarSign } from '../../helper';
import RatingStars from '../RatingStars';
import Footer from '../Footer';

import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import Grid from '@material-ui/core/Grid';
import Chip from '@material-ui/core/Chip';

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  card: {
    //maxWidth: 345,
    //minWidth: 375,
    margin: 8,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    textDecoration: 'none',
    color: theme.palette.secondary.contrastText,
    [theme.breakpoints.up('md')]: {
      //height: '34vh',
      margin: 2,
    },
  },
  media: {
    //objectFit: 'contain',
    //height: 160,
    // paddingTop: '56.25%', // 16:9,
    // marginTop:'30'
    //maxWidth: '100%',
    //maxWidth: 275,
    // height: 'auto',
    //minWidth: '375',
    height: '20vh',
    'object-fit': 'contain',
    [theme.breakpoints.up('md')]: {
      minWidth: 270,
    },
  },
  model_yr_make: {
    'font-size': '12px',
    'line-height': '1',
    'letter-spacing': 'normal',
  },
  uppercase_title: {
    'text-transform': 'uppercase',
  },
  uppercase_right_align: {
    'text-transform': 'uppercase',
    'text-align': 'right',
  },
  uppercase_right_align_month: {
    'text-transform': 'uppercase',
    'text-align': 'right',
    marginTop: -5,
  },
  lease_monthly_payment: {
    'color': theme.palette.primary.main,
    'text-align': 'right',
  },
  cardContent: {
    backgroundColor: theme.palette.background.default,
    // paddingTop: '8px',
    // paddingBottom: '8px',
    //padding: '12px',
    //height: '20vh',
  },
  chip: {
    position: 'absolute',
    margin: theme.spacing.unit,
    zIndex: 2,
    right: -2,
    //top: 2,
    bottom: 90,
    backgroundColor: theme.palette.primary.light,
    opacity: '0.8',
  },
});

String.prototype.trimEllip = function (length) {
  return this.length > length ? this.substring(0, length) + "..." : this;
}

class Deals extends Component{

  constructor(props) {
    super(props);

    this.state = {
      showNoMatchFoundMsg: false,
    };

  }

    handleDealClick = () => {
      //console.log('list item clicked');
    };

    imgError = (event) => {
      event.target.src = "http://hipkar.com.s3.amazonaws.com/images/placeholder.png";
      //console.log('img could not be loaded');
    };

    componentDidUpdate(prevProps) {
      // Typical usage (don't forget to compare props):
      if (this.props.list !== prevProps.list) {
        //console.log('Deals: list changed. Len: ' + this.props.list.length);
        if(this.props.list.length === 0) {
          this.setState({
            showNoMatchFoundMsg: true,
          });
        } else {
          this.setState({
            showNoMatchFoundMsg: false,
          });
        }
      }
    }

    formatTresCommas(val) {
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    calculateMilesPerYear (deal) {
      //const { deal } = this.state;

      let total_miles_allowed = parseInt(deal.totalMilesAllowed.replace(/,/g, ''), 10);
      let lease_months = parseInt(deal.leaseMonths, 10);
      // if (deal.make === 'infiniti'){
      //   console.log('leaseMonths: ' + lease_months);
      //   console.log('total_miles_allowed: ' + total_miles_allowed);
      // }
      return this.formatTresCommas(Math.round(total_miles_allowed / (lease_months/12)))
    }

    render() {
        const { classes, list, leasyZip } = this.props;
        const { showNoMatchFoundMsg } = this.state;
        //const sortedList = list.sort((a,b) => parseFloat(a['valueScore']) > parseFloat(b['valueScore'])?1:-1)
        //let f_list = [];
        // if(list)
        //   console.log('list length: ' + list.length);
        if (list) {
          for(let i=0; i<list.length; i++){
              if (!list[i].offerImage)
                list[i]['offerImage'] = "http://hipkar.com.s3.amazonaws.com/images/placeholder.png";
                //f_list.push(list[i]);
          }
        }

        return (
          <div className={classes.root}>

              {(list && (list.length !== 0)) ?
              <div className={classes.root}>

                <Grid container alignItems="stretch" justify="center" spacing={8}>
                  { list && list.map((data, i) =>
                    <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                      <Card className={classes.card} square={true} elevation={0} component={Link} to={'/deals/detail/' + data.id}>
                        <CardActionArea>
                          {data.localOffer && (data.localOffer === "True") ?
                          <Chip label="Local Special" className={classes.chip} />
                          : ''}
                          <CardMedia
                            component="img"
                            className={classes.media}
                            image={data.offerImage}
                            onError={this.imgError}
                            title={data.model}
                          />
                          <CardContent className={classes.cardContent}>
                            <Grid container alignItems="stretch" justify="space-between" spacing={0}>
                              <Grid item xs={8}>
                                <Typography className={classes.uppercase_title} variant="caption" display="block" gutterBottom>
                                  {data.year} {data.make}
                                </Typography>
                                <Typography gutterBottom variant="h4" component="h2">
                                   {data.model.trimEllip(14)}
                                </Typography>
                              </Grid>
                              <Grid item xs={4}>
                                <Typography className={classes.uppercase_right_align} variant="caption" display="block" gutterBottom>
                                  AS LOW AS
                                </Typography>
                                <Typography className={classes.lease_monthly_payment} gutterBottom variant="h4" component="h2">
                                   {"$" + removeDollarSign(data.leaseMonthlyPayment)}
                                </Typography>
                                <Typography className={classes.uppercase_right_align_month} variant="caption" display="block" gutterBottom>
                                  /MONTH
                                </Typography>
                              </Grid>
                            </Grid>
                            <Grid container alignItems="stretch" justify="center" spacing={8}>
                              <Grid item xs={6}>
                                <Typography className={classes.uppercase_title} variant="caption" display="block" gutterBottom>
                                  {data.leaseMonths} months
                                </Typography>
                              </Grid>
                              <Grid item xs={6}>
                                <Typography className={classes.uppercase_right_align} variant="caption" display="block" gutterBottom>
                                  {this.calculateMilesPerYear(data)} miles/yr
                                </Typography>
                              </Grid>
                            </Grid>

                          </CardContent>
                        </CardActionArea>
                      </Card>
                    </Grid>
                  )}
                </Grid>
                <div><br/></div>
                <Footer leasyZip={leasyZip}/> 
            </div> :
             (showNoMatchFoundMsg) ?
              <Typography gutterBottom variant="display1" component="h2">
                 No offers matched the filter criteria. Please change or reset the filter and try again.
              </Typography>
              : <CircularProgress className={classes.progress} />
            }
          </div>
        );
    }
}

export default withStyles(styles)(Deals);

//<div className={classes.numberCircle}>{(i+1)}</div>



// WEBPACK FOOTER //
// ./src/components/dashboard/DealTiles.jsx